import { clampToInputBounds } from './clampToInputBounds';
import { findPanelResizeInput } from './findPanelResizeInput';
import { getSplitLayoutTargetWidth } from './getSplitLayoutTargetWidth';

/**
 * Refreshes the enclosing panel splitter's bounds, then reports the width the panel can actually
 * reach. Waiting one frame is required because the Nav4 splitter updates its range-input bounds in
 * React state when the hidden input receives focus.
 */
export const getExpandedPanelWidth = (
	fromElement: HTMLElement | null,
	onWidthReady: (width: number | null) => void,
): void => {
	if (typeof window === 'undefined') {
		onWidthReady(null);
		return;
	}

	const input = findPanelResizeInput(fromElement);
	if (!input) {
		onWidthReady(null);
		return;
	}

	input.focus();
	const readRefreshedWidth = () => {
		onWidthReady(clampToInputBounds(input, getSplitLayoutTargetWidth()));
	};

	if (typeof requestAnimationFrame === 'function') {
		requestAnimationFrame(readRefreshedWidth);
	} else {
		readRefreshedWidth();
	}
};
